import React from 'react';
import {Button, Input, Tooltip} from 'antd';
import {
  CloseOutlined,
  LoadingOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import FilterSelect from '../MainPage/FilterSelect.jsx';

const DocumentSidebar = ({
  options,
  filters,
  onFilterChange,
  onClearFilters,
  onFreeSearch,
  searchValue,
  onSearchValueChange,
  isLoadingFreeSearch,
  totalDocuments,
  showModeratorButtons,
  onOpenModeratorPanel,
  onOpenUsageStatistic,
  onOpenAudit,
  showModeratorButtonForExternalUser,
}) => {
  const handleFreeSearchChange = e => {
    onSearchValueChange(e.target.value);
    if (e.target.value == null || e.target.value === '') {
      onClearFilters();
    }
  };

  const handleSearchClick = () => {
    onFreeSearch([searchValue]);
  };

  return (
    <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
      <hr
        style={{
          border: 'none',
          borderTop: '1px solid #e0e0e0',
          margin: '0 16px',
        }}
      />

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          margin: '6px 16px',
        }}
      >
        <Button
          type="link"
          icon={<CloseOutlined />}
          onClick={onClearFilters}
          style={{
            padding: 0,
            fontSize: '14px',
            color: 'rgb(49, 49, 49)',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          Clear all filters
        </Button>
      </div>

      <hr
        style={{
          border: 'none',
          borderTop: '1px solid #e0e0e0',
          margin: '0 16px',
        }}
      />

      <div style={{flex: 1, overflowY: 'auto'}}>
        <FilterSelect
          options={options.countries}
          placeholder="Select country"
          value={filters.countryCode}
          onChange={val => onFilterChange('countryCode', val)}
        />
        <FilterSelect
          options={options.documentTypes}
          placeholder="Select document type"
          value={filters.documentType}
          onChange={val => onFilterChange('documentType', val)}
        />
        <FilterSelect
          options={options.states}
          placeholder="Select state"
          value={filters.state}
          onChange={val => onFilterChange('state', val)}
        />
        <FilterSelect
          options={options.documentVersions}
          placeholder="Select version"
          value={filters.documentVersion}
          onChange={val => onFilterChange('documentVersion', val)}
        />
        <FilterSelect
          options={options.yearsOfIssue}
          placeholder="Select year of issue"
          value={filters.yearOfIssue}
          onChange={val => onFilterChange('yearOfIssue', val)}
        />
        <FilterSelect
          options={options.aliases}
          placeholder="Select alias"
          value={filters.alias}
          onChange={val => onFilterChange('alias', val)}
        />
        <FilterSelect
          options={options.statusCodes}
          placeholder="Select single/couple"
          value={filters.statusCode}
          onChange={val => onFilterChange('statusCode', val)}
        />
        <FilterSelect
          options={options.supportedFrom}
          placeholder="Select Sdr version"
          value={filters.supportedFrom}
          onChange={val => onFilterChange('supportedFrom', val)}
        />

        <hr
          style={{
            width: 'auto',
            border: 'none',
            borderTop: '0.5px dotted #000',
            margin: '18px',
          }}
        />

        <div style={{margin: '16px', display: 'flex', alignItems: 'center'}}>
          <Tooltip title="Search documents by terms. Use commas to separate terms (e.g., '2019,USA') and '-' to exclude (e.g., '2019,-english').">
            <Input
              value={searchValue != null ? searchValue : filters?.freeSearch}
              onChange={handleFreeSearchChange}
              placeholder="Free search..."
              style={{
                padding: '10px',
                height: '35px',
                flexGrow: 1,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
              }}
            />
          </Tooltip>

          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSearchClick}
            style={{
              height: '35px',
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '45px',
            }}
          />
        </div>

        {isLoadingFreeSearch && (
          <p style={{color: 'gray', fontSize: '14px', margin: '16px'}}>
            Please wait, this search may take a little longer than usual.{' '}
            <LoadingOutlined />
          </p>
        )}

        <hr
          style={{
            width: 'auto',
            border: 'none',
            borderTop: '0.5px dotted #000',
            margin: '18px',
          }}
        />
        <div
          style={{
            textAlign: 'left',
            margin: 16,
            position: 'sticky',
            bottom: 0,
            backgroundColor: 'white',
            padding: '8px',
            boxShadow: '0 1px 10px rgba(0, 0, 0, 0.1)',
          }}
        >
          <p
            style={{
              fontSize: '14px',
              borderRadius: '8px',
              marginLeft: '2px',
              marginBottom: '8px',
            }}
          >
            Found documents: {totalDocuments}
          </p>
        </div>
        <div
          style={{
            backgroundColor: 'white',
            padding: '8px 16px',
            borderTop: '1px solid #e0e0e0',
          }}
        >
          {showModeratorButtons && (
            <div style={{marginTop: '10px'}}>
              <Button
                type="primary"
                style={{fontWeight: 700, width: '100%', marginBottom: '8px'}}
                onClick={onOpenModeratorPanel}
              >
                Moderator Console
              </Button>

              <Button
                type="primary"
                style={{fontWeight: 700, width: '100%'}}
                onClick={onOpenAudit}
              >
                Data Transfer Audit
              </Button>
            </div>
          )}
          {showModeratorButtonForExternalUser || showModeratorButtons ? (
            <div style={{marginTop: '10px'}}>
              <Button
                type="primary"
                style={{fontWeight: 700, width: '100%', marginBottom: '8px'}}
                onClick={onOpenUsageStatistic}
              >
                Usage Statistic
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default DocumentSidebar;
